/* eslint-disable no-useless-catch */
let tokenRefreshPromise = null;

export class TokenManager {
  static getInstance() {
    if (!TokenManager.instance) {
      TokenManager.instance = new TokenManager();
    }
    return TokenManager.instance;
  }

  static async refreshToken() {
    if (!tokenRefreshPromise) {
      tokenRefreshPromise = (async () => {
        try {
          // Check if refresh function is available in global context
          if (window.ORIGINATORPLATFORM && window.ORIGINATORPLATFORM.refreshAccessToken) {
            const { refreshAccessToken } = window.ORIGINATORPLATFORM;
            await refreshAccessToken();
          } else {
            console.warn("Token refresh function not available in global context");
            throw new Error("Token refresh function not available");
          }
        } catch (error) {
          throw error;
        } finally {
          tokenRefreshPromise = null;
        }
      })();
    }
    return tokenRefreshPromise;
  }
}
